"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogoAxon = _ref => {
  var {
    width = "5rem"
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("img", {
    style: {
      width
    },
    src: "https://axon-campus.s3.us-east-2.amazonaws.com/otros/axon_logo_blanco.png",
    alt: "Logotipo de axon training"
  });
};

var _default = LogoAxon;
exports.default = _default;